import TakeawayOrderDetailList from '../../components/TakeawayOrderDetailList'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import * as basketActions from '../../actions/components/basket'
import * as promocodesActions from '../../actions/components/promocodes'

import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router'
import _ from 'lodash'
const mapStateToProps = (state) => {
  return {
    ..._.pick(state, ['merchant', 'basket', 'orders', 'takeawayWaitingBasket', 'promocodes']),
    promoCode: state.basket.promoCode,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(basketActions, dispatch),
    ...bindActionCreators(promocodesActions, dispatch),
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(TakeawayOrderDetailList)))



// WEBPACK FOOTER //
// ./src/containers/components/TakeawayOrderDetailList.js